import { useEffect, useState } from 'react';

import { SkeletonCard } from '../SkeletonCard/SkeletonCard';

import { Root } from './Loader.ui';

const OTHER_ELEMENTS_HEIGHT = 172;
const HORIZONTAL_PADDING = 16;
const CARDS_IN_A_ROW = 2;
const CARD_NAME_HEIGHT = 16;
const HORIZONTAL_RATIO = 197;
const VERTICAL_RATIO = 136;
const SHADOW_CARD_COUNT = 1;

export const Loader = () => {
  const [count, setCount] = useState(20);

  useEffect(() => {
    const calculateCount = () => {
      const windowHeight = window.innerHeight;
      const totalHeight = windowHeight - OTHER_ELEMENTS_HEIGHT;

      const windowWidth = window.innerWidth;
      const cardWidth = (windowWidth - HORIZONTAL_PADDING * 2) / CARDS_IN_A_ROW;
      const cardHeight =
        CARD_NAME_HEIGHT + (cardWidth * VERTICAL_RATIO) / HORIZONTAL_RATIO;

      const calculatedCount =
        (Math.floor(totalHeight / cardHeight) + SHADOW_CARD_COUNT) *
        CARDS_IN_A_ROW;
      setCount(calculatedCount);
    };

    calculateCount();
    window.addEventListener('resize', calculateCount);

    return () => window.removeEventListener('resize', calculateCount);
  }, []);

  // запрещаем скролл страницы при показе лоадеров
  useEffect(() => {
    const bodyTag = document.body;

    if (bodyTag) {
      bodyTag.style.overflow = 'hidden';
      return () => {
        bodyTag.style.overflow = 'auto';
      };
    }
  }, []);

  return (
    <Root>
      {Array.from({ length: count }).map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <SkeletonCard key={i} />
      ))}
    </Root>
  );
};

// 56 + 84
